import sizeChart from "./components/size-chart";
import valuePropsSlider from "./components/value-props";
import redesign_plp from "./components/redesign-plp";
import observeChanges from "./components/redesign-plp_observer";
import { newSearchFunctionallity } from './components/search-components';
import { wishList } from './components/wishlist';
import { lookbookSwipers } from './components/lookbook-carousel';
import popUpCart from './components/popup-cart';
import initBlogArticleDesign from './components/blog-article-list';
import initializePdmFiltersProductCards from './components/pdm-filters-product-card';
import initializeSideCartListener from './components/sidecart';
import initScrollHeaderUp from './components/header';
import { register as registerSwiperComponent } from "swiper/element";
import initSocialProof from './components/social-proof'
import initHomeBlogSwiper from './components/blog-home-article';
import reviewsSection from './components/reviews-homepage';
import { infoCards } from './components/info-cards';

registerSwiperComponent(); // method from swiperRegister element
document.addEventListener('DOMContentLoaded', () => {
  sizeChart();
  valuePropsSlider();
  redesign_plp();
  observeChanges();
  initScrollHeaderUp();
  newSearchFunctionallity();
  wishList();
  lookbookSwipers()
  popUpCart();
  initBlogArticleDesign();
  initializePdmFiltersProductCards();
  initializeSideCartListener();
  initSocialProof();
  initHomeBlogSwiper();
  reviewsSection();
  infoCards();

  let closeButtonFilterSideMenu = document.querySelector('.btn-close-sidebar')
  let filterSideMenu = document.querySelector('.js-sidebar');

  if (closeButtonFilterSideMenu && filterSideMenu) {
    closeButtonFilterSideMenu.addEventListener('click', () => {
      filterSideMenu.classList.remove('active');
      document.body.classList.remove('no-scroll');
    });
  }

});
document.addEventListener('load', () => {
  // html smooth scroll and top position after redirection
  const hash = window.location.hash;
  console.log(hash);
  if (hash) {
    const element = document.querySelector(hash);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', top: element.offsetTop });
    }
  }
});
